/* Close header dropdown on clicks outside; Dawn handles Escape and drawer navigation. */
document.addEventListener('pointerdown', function (event) {
 const details = document.getElementById('Details-HeaderMenu-CBRNTools');
 if (!details || !details.open || details.contains(event.target)) return;
 details.open = false;
 const summary = details.querySelector('summary');
 if (summary) summary.setAttribute('aria-expanded', 'false');
});
